import last from 'lodash/last';
import { TRAVELMODE_DONE } from 'utils/directions/constants';
import getDistance from 'utils/getDistance';
import { STATUS_NONE, STATUS_START, STATUS_EDITING } from '../constants';

let legId = 0;

function getId() {
  legId++;
  return `leg_${legId.toString().padStart(5, '0')}`;
}

function Leg(points, travelMode) {
  this.id = getId();
  this.points = points;
  this.routing = points.length > 1 ? travelMode : TRAVELMODE_DONE;
  this.lastPoint = last(points);
  this.distance = getDistance(points);
}

export function legDistances(legs) {
  return legs.reduce((sum, leg) => sum + leg.distance, 0);
}

export function toRoute(legs) {
  let points = [];
  const waypoints = [0];
  let distance = 0;
  legs.forEach(leg => {
    const newPoints = points.length > 0 ? leg.points.slice(1) : leg.points;
    points = points.concat(newPoints);
    distance += leg.distance;
    waypoints.push(points.length);
  });
  return { points, waypoints, distance };
}

export function editStatus(legs) {
  if (legs === undefined) {
    return STATUS_NONE;
  }
  return legs.length === 0 ? STATUS_START : STATUS_EDITING;
}

export default Leg;
